export const displayBadgeCount = (count: number, max: number): string | number | null => {
  const displayText = count < max ? count : `${max}+`
  return displayText || 0
}
